import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { errorMessage } from '../../services/errors';
import { authError, authInput, authSubmit, tapLink } from '../../components/styles';
import AuthLayout from './AuthLayout';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { signIn } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await signIn(email, password);
      navigate('/');
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to Cerebro Diem">
      <form onSubmit={handleSubmit} className="space-y-4">
        {error && (
          <div className={authError} role="alert">
            {error}
          </div>
        )}

        <div>
          <label htmlFor="login-email" className="block text-sm font-medium mb-2">
            Email
          </label>
          <input
            id="login-email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={authInput}
            required
          />
        </div>

        <div>
          {/* The link's 44px height hangs into the margin, so the label and the field stay where they were. */}
          <div className="flex items-center justify-between mb-2">
            <label htmlFor="login-password" className="block text-sm font-medium">
              Password
            </label>
            <Link
              to="/forgot-password"
              state={{ email }}
              className={`${tapLink} -my-3 pointer-fine:my-0 text-sm text-primary font-medium hover:underline`}
            >
              Forgot password?
            </Link>
          </div>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={authInput}
            required
          />
        </div>

        <button type="submit" disabled={isLoading} className={authSubmit}>
          {isLoading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>

      <p className="mt-6 text-center text-sm text-on-surface-variant">
        Cerebro is invite-only for now. If you were invited, open the link in your invitation
        email to set your password.
      </p>
    </AuthLayout>
  );
}
